import { render, staticRenderFns } from "./ActivityReservation.vue?vue&type=template&id=24fdbfc5&scoped=true&"
import script from "./ActivityReservation.vue?vue&type=script&lang=js&"
export * from "./ActivityReservation.vue?vue&type=script&lang=js&"
import style0 from "./ActivityReservation.vue?vue&type=style&index=0&id=24fdbfc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fdbfc5",
  null
  
)

export default component.exports